export const CUSTOMERCARD = "customercard";
export const OBJECT = "object";
